import { useEffect } from 'react';

/**
 * Sync VisualViewport metrics to CSS custom properties so fixed bottom sheets
 * stay above the iOS keyboard without resizing the whole app shell.
 *
 * --vv-height, --vv-offset-top, --vv-keyboard-inset
 */
export function useVisualViewportVars(enabled = true) {
  useEffect(() => {
    if (!enabled || typeof window === 'undefined') return;

    const root = document.documentElement;

    const sync = () => {
      const vv = window.visualViewport;
      if (!vv) {
        root.style.setProperty('--vv-height', '100dvh');
        root.style.setProperty('--vv-offset-top', '0px');
        root.style.setProperty('--vv-keyboard-inset', '0px');
        return;
      }

      const keyboardInset = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
      root.style.setProperty('--vv-height', `${vv.height}px`);
      root.style.setProperty('--vv-offset-top', `${vv.offsetTop}px`);
      root.style.setProperty('--vv-keyboard-inset', `${keyboardInset}px`);
    };

    sync();
    window.visualViewport?.addEventListener('resize', sync);
    window.visualViewport?.addEventListener('scroll', sync);
    window.addEventListener('orientationchange', sync);

    return () => {
      window.visualViewport?.removeEventListener('resize', sync);
      window.visualViewport?.removeEventListener('scroll', sync);
      window.removeEventListener('orientationchange', sync);
      root.style.removeProperty('--vv-height');
      root.style.removeProperty('--vv-offset-top');
      root.style.removeProperty('--vv-keyboard-inset');
    };
  }, [enabled]);
}
